// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticlesFilters_wrapper__mMryN"};